<template>
    <div class="notice-box" v-if="notices && notices.length > 0">
        <img src="//file.40017.cn/appresource/image/forStudent/new/icon_notice.png" alt="" class="icon-notice"/>
        <van-swipe
            class="notice"
            :autoplay="3000"
            style="height: 34px;"
            vertical :touchable="false"
            :show-indicators="false"
            @change="onChangeNotice">
            <van-swipe-item
                class="notice-swipe-item"
                v-for="(infoItem, index) in notices"
                :key="index"
                @click="bannerJump(infoItem, 1)">
                {{ infoItem.notice }}
            </van-swipe-item>
        </van-swipe>
        <!-- <img class="icon-close" src="//file.40017.cn/appresource/image/forStudent/new/icon_close_grey@2x.png" alt="" @click="closeNotices"> -->
    </div>
</template>

<script>
import { Swipe, SwipeItem, Toast, Icon } from 'vant';
import { toPage, randomString } from "@/utils/tools";

export default {
    name: 'notice',
    props: {
        notices: {
            type: Array,
            default: () => []
        }
    },
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Icon.name]: Icon,
    },
    data() {
        return {
            noticess: [ // mock数据
                {
                    notice: "新客链接测试新客链接测试新客链接测试新客链接测试新客链接测试",
                    url: "https://m.17u.cn/couponstore/customer?wvc3=1&tcwvclogin"
                },
                {
                    notice: "新客链接测试",
                    url: "https://m.17u.cn/couponstore/customer?wvc3=1&tcwvclogin"
                }
            ]
        }
    },
    mounted() {

    },
    methods: {
        onChangeNotice(index) {
            this.$emit('setTrack', {
                action: 'students_notice_show',
                label: '公告曝光',
                value: {"channel":"学生专区","scene":"公共","content": this.notices[index].notice,"state": "是"}
            })
        },
        bannerJump(info, type) {
            this.$emit('setTrack', {
                action: 'students_notice_click',
                label: '公告点击',
                value: {"channel":"学生专区","scene":"公共","content": info.notice,"state": "是"}
            })
            toPage(info.url)
        },
        // closeNotices() {
        //     this.$emit('setTrack', {
        //         action: 'students_notice_close',
        //         label: '公告关闭',
        //         value: {"channel":"学生专区","scene":"公共"}
        //     })
        //     // this.$emit('closeNotices')
        // }
    },
    watch: {
        notices: {
            handler: function (val, oldVal) {
                if(val && val.length){
                    this.onChangeNotice(0)
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="less" scoped>
.notice-box {
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 83px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 34px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.7);
    color: #888888;
    font-size: 14px;
    text-align: center;
    padding: 0 12px;
    // margin-top: -88px;
    .icon-notice {
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 18px;
        margin-right: 10px;
    }
    .notice {
        flex: 1;
        line-height: 34px;
        text-align: left;
        .notice-swipe-item {
            max-width: 300px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .icon-close {
        display: inline-block;
        width: 26px;
        height: 26px;
        line-height: 26px
    }
}
</style>>
